export let modalStack: (() => void)[] = [];

export const registerModal = (onClose: () => void) => {
	modalStack.push(onClose);
};

export const unregisterModal = (onClose: () => void) => {
	modalStack = modalStack.filter(fn => fn !== onClose);
};

export const closeTopModal = () => {
	const top = modalStack.pop();

	top?.();
};
